import {useDroppable} from "@dnd-kit/core";
import {Clone, E} from "js-vextensions";
import {Button, Column, Row, Text} from "react-vcomponents";
import {BaseComponent, GetDOM} from "react-vextensions";
import {ShowMessageBox} from "react-vmessagebox";
import {ES, Observer} from "web-vcore";
import React from "react";
import {AlarmsComp} from "../../../../Engine/LiveSession/Components/AlarmsComp.js";
import {DeleteJournalEntry} from "../../../../Server/Commands/JournalEntryCommands.js";
import {UpdateJournalEntry} from "../../../../Server/Commands/JournalEntryCommands.js";
import {GetEntity} from "../../../../Server/DB/entities.js";
import {Entity} from "../../../../Server/DB/entities/@Entity.js";
import {GetJournalEntries} from "../../../../Server/DB/journalEntries.js";
import {GetWordsInDreamSegment_Array, JournalEntry, JournalSegment} from "../../../../Server/DB/journalEntries/@JournalEntry.js";
import {MeID} from "../../../../Server/DB/users.js";
import {store} from "../../../../Store/index.js";
import {DNDInfo} from "../../../@Root/DNDStructures.js";
import {JournalSegmentUI} from "../SegmentUI.js";
import {GetLiveSession_Reactive, GetLiveLocalSession_Reactive} from "../../../../Engine/LiveSessionManagement.js";
import {observer_mgl} from "mobx-graphlink";
import {GetWordsInText_Array} from "../../../../Utils/Search/StringToWords.js";
import {sessionChartColors} from "../../../Timeline/Sessions/SessionUI/SessionChartColors.js";
import {GetDreamAnchorEntities, GetDreamAnchorEntity} from "../../../../Server/DB/journalEntries/$journalEntry.js";

export function GetTermCountForEntityAnchor(entity: Entity) {
	const dreams = GetJournalEntries(MeID());
	const segments = dreams.SelectMany(a=>a.segments);
	//return segments.filter(a=>GetDreamAnchorEntity(a) == entity.id) // only base on first anchor-entity atm (since that's only one shown)
	return segments.filter(a=>GetDreamAnchorEntities(a).includes(entity.id))
		.map(a=>GetWordsInDreamSegment_Array(a, "longText", false, false).length).concat(0).Sum();
}

export function GetSegmentActionButtonWidthInColumns(segment: JournalSegment) {
	const anchorEntity = GetDreamAnchorEntity(segment) ? GetEntity(GetDreamAnchorEntity(segment)) : null;
	const showAnchorEntity = anchorEntity?.image_embedded && store.main.engine.journey.showAnchorEntities;
	return showAnchorEntity ? 2 : 1;
}

export const SegmentActionButton = observer_mgl((props: {parentDroppableInfo: DNDInfo|n, journalEntry: JournalEntry, segment: JournalSegment, onClick: ()=>any})=>{
	const {parentDroppableInfo, journalEntry, segment, onClick} = props;
	const segmentIndex = journalEntry.segments.indexOf(segment);

	const terms_short = GetWordsInText_Array(segment.shortText ?? "", false);
	const terms_long = GetWordsInText_Array(segment.longText ?? "", false);
	const termCount = Math.max(terms_short.length, terms_long.length);
	const colorForWordCount = E(
		terms_short.length == 0 && terms_long.length == 0 && {color: "rgba(255,0,0,1)"},
		terms_short.length > 0 && terms_long.length == 0 && {color: "rgba(255,128,0,1)"},
		terms_short.length == 0 && terms_long.length > 0 && {color: "rgba(255,255,0,1)"},
		terms_short.length > 0 && terms_long.length > 0 && {color: "rgba(0,255,0,1)"},
		segment.wakeTime != null && {color: "white"}, // wake segments always use white text
	)["color"] ?? "white";

	const anchorEntity = GetDreamAnchorEntity(segment) ? GetEntity(GetDreamAnchorEntity(segment)) : null;
	const showAnchorEntity = anchorEntity?.image_embedded && store.main.engine.journey.showAnchorEntities;
	/*const buttonSizeInColumns = GetSegmentActionButtonWidthInColumns(segment);
	const columnSizeAsFraction = 1 / columns;
	const buttonWidth = (buttonSizeInColumns * columnSizeAsFraction).ToPercentStr();*/
	const buttonWidth = showAnchorEntity ? 80 : 40;

	const droppableInfo = new DNDInfo({
		type: "RemoveEntityFromSequenceButton",
		parentDroppableInfo: parentDroppableInfo ?? undefined,
	});
	const droppableID = JSON.stringify(droppableInfo);
	const {isOver, setNodeRef} = parentDroppableInfo ? useDroppable({id: droppableID, data: droppableInfo}) : {} as ReturnType<typeof useDroppable>;

	let borderStyle: any;
	if (segment.lucid) borderStyle = {border: `2px solid ${sessionChartColors.waking_lucid}`};
	else if (segment.semiLucid) borderStyle = {border: `2px solid ${sessionChartColors.waking_semiLucid}`};
	else if (segment.ordered) borderStyle = {border: "2px solid rgba(0,255,0,1)"};

	if (showAnchorEntity) {
		const hitCount = GetTermCountForEntityAnchor(anchorEntity);
		return (
			<Row onClick={onClick} style={ES(
				{position: "relative", width: buttonWidth, flexShrink: 0, cursor: "pointer"},
				borderStyle,
			)}>
				<img ref={c=>setNodeRef && setNodeRef(c as any)} src={anchorEntity.image_embedded!} style={{width: `100%`, height: "auto", border: "1px solid rgba(255,255,255,.3)"}}/>
				<div style={{
					position: "absolute", left: 0, right: 0, bottom: 0, background: "rgba(0,0,0,.7)",
					height: 18, lineHeight: "18px", fontSize: 16, fontWeight: "bold",
					color: "rgba(255,255,255,1)", textShadow: "rgb(10, 10, 10) -1px 0px, rgb(10, 10, 10) 0px 1px, rgb(10, 10, 10) 1px 0px, rgb(10, 10, 10) 0px -1px",
				}}>
					<div style={{position: "absolute", left: 3, right: 3, bottom: 0, textAlign: "left"}}>
						{hitCount}
					</div>
					<div style={{position: "absolute", left: 3, right: 3, bottom: 0, textAlign: "right", color: colorForWordCount}}>
						{termCount}
					</div>
				</div>
			</Row>
		);
	}

	return (
		<Row ref={c=>setNodeRef && setNodeRef(GetDOM(c) as any)}
			style={ES(
				{
					width: buttonWidth, flexShrink: 0,
					//width: `${(100 / columns) * 2}%`,
					aspectRatio: segment.wakeTime != null || segment.longText.trim().length == 0 ? "1/.5" : "1/1",
					border: "1px solid rgba(255,255,255,.3)"
				},
				borderStyle,
			)}>
			<Button text={termCount + ""}
				style={{
					padding: 0,
					//flex: 1, aspectRatio: "1/1",
					width: "100%", height: "100%",
					color: colorForWordCount,
				}}
				onClick={onClick}/>
		</Row>
	);
});